var Queensland = "كوينزلاند";
var Tasmania = "تسمانيا";
var Victoria = "فيكتوريا";
var AUStates = {
	"Australian Capital Territory": "إقليم العاصمة الأسترالية",
	"New South Wales": "نيو ساوث ويلز",
	"Northern Territory": "الإقليم الشمالي",
	Queensland: Queensland,
	"South Australia": "جنوب أستراليا",
	Tasmania: Tasmania,
	Victoria: Victoria,
	"Western Australia": "أستراليا الغربية"
};

export { Queensland, Tasmania, Victoria, AUStates as default };
